import React, {Component} from 'react';
import api from "api";
import ApplicationTable from "components/Application/ApplicationTable";
import SearchTextInput from "components/Application/ApplicationTable/SearchTextInput";
import {Link} from "react-router-dom";
import appRoutes from "../../../../appRoutes";
import Select from "react-select";

class AnkieteoCmsTable extends Component {

  constructor(props) {
    super(props);

    this.tableRef = React.createRef();

    this.state = {
      filters: {
        level: 0,
      }
    }

    this.changeFilter = this.changeFilter.bind(this);
  }

  changeFilter(key, value){
    this.setState({
      filters: {
        ...this.state.filters,
        [key]: value
      }
    }, () => {
      this.tableRef.current.setFilters(this.state.filters);
      this.tableRef.current.fetchDataDelay(1);
    })
  }

  render() {
    const {filters} = this.state;

    const columns = [
      {
        id: 'parent',
        Header: 'Dział',
        width: 250,
        accessor: row => row.parent ? row.parent.name : ''
      },
      {
        id: 'name',
        Header: 'Nazwa',
        accessor: row => row.name
      },
      {
        id: 'action',
        Header: '',
        width: 100,
        accessor: row => {
          return <div className="d-flex">
            <Link to={appRoutes.admin.cms.ankieteo.edit(row.id)}><i className="fas fa-edit" /></Link>
          </div>
        }
      },
    ];

    return <React.Fragment>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <Link className="btn btn-primary d-block" to={appRoutes.admin.cms.ankieteo.add}><i className="fas fa-plus" /> Dodaj</Link>
        <div className="d-flex ml-auto">
          <div className="mr-2" style={{width: '200px'}}>
            <Select
              value={{
                label: ' Level ' + filters.level,
                value: filters.level,
              }}
              options={[0, 1].map(level => {
                return {
                  label: ' Level ' + level,
                  value: level,
                };
              })}
              onChange={option => this.changeFilter('level', option.value)}
            />
          </div>
          <SearchTextInput
            tableRef={this.tableRef}
          />
        </div>
      </div>
      <ApplicationTable
        ref={this.tableRef}
        columns={columns}
        fetchData={api.ankieteoCms.search}
        deleteData={api.ankieteoCms.delete}
        filters={filters}
      />
    </React.Fragment>;
  }
}

export default AnkieteoCmsTable;
